import { initialStandardCrudErrorsState, StandardCrudErrors } from '@app/shared/store/standard-crud-errors.state';
import { EntityState } from '@ngrx/entity';
import { DateTime, Duration } from 'luxon';

export interface StandardEntityState<T> extends EntityState<T> {
  /**
   * The selectedId 'new' is reserved.
   */
  selectedId: number | 'new';
  errors: StandardCrudErrors;
  adding: boolean;
  updating: boolean;
  deleting: boolean;

  /**
   * null if not loading all
   * ISO8601 timestamp if loading all
   */
  loadingAllAt: string;
  loadedAll: boolean;

  /**
   * null is not loaded all
   * ISO8601 timestamp if loaded all
   */
  loadedAllAt: string;
  defaultMaxAge: string;
}

export const initialStandardEntityState = {
  selectedId: null,
  errors: initialStandardCrudErrorsState,
  adding: false,
  updating: false,
  deleting: false,
  loadingAllAt: null,
  loadedAll: false,
  loadedAllAt: null,
  defaultMaxAge: 'PT60M',
};

export interface LoadingMetadata {
  loadingAt: DateTime | null;
  loadedAt: DateTime | null;
  defaultMaxAge: Duration | null;
}

export const selectSelectedId = <T>(state: StandardEntityState<T>) => state.selectedId;
export const selectErrors = <T>(state: StandardEntityState<T>) => state.errors;
export const selectAdding = <T>(state: StandardEntityState<T>) => state.adding;
export const selectUpdating = <T>(state: StandardEntityState<T>) => state.adding;
export const selectSaving = <T>(state: StandardEntityState<T>) => state.adding || state.updating;
export const selectDeleting = <T>(state: StandardEntityState<T>) => state.deleting;
export const selectLoadedAll = <T>(state: StandardEntityState<T>) => state.loadedAll;
export const selectLoadingAll = <T>(state: StandardEntityState<T>) =>
  state.loadingAllAt && DateTime.fromISO(state.loadingAllAt);
export const selectLoadedAllAt = <T>(state: StandardEntityState<T>) =>
  state.loadedAllAt && DateTime.fromISO(state.loadedAllAt);
export const selectLoadedAllMetadata = <T>(state: StandardEntityState<T>) => ({
  loadingAt: state.loadingAllAt && DateTime.fromISO(state.loadingAllAt),
  loadedAt: state.loadedAllAt && DateTime.fromISO(state.loadedAllAt),
  defaultMaxAge: state.defaultMaxAge && Duration.fromISO(state.defaultMaxAge),
});

export const selectSelected = <T>(state: StandardEntityState<T>) => {
  if (state?.selectedId === 'new') {
    return {} as T;
  } else {
    return state?.selectedId && state.entities[state.selectedId];
  }
};
